export default "__VITE_ASSET__YzGORCJl__"